import { Scheduler, MonthView, DayView, WeekView, SchedulerSlot, SchedulerDataChangeEvent, SchedulerItemProps, SchedulerItem, SchedulerEditItemProps, SchedulerEditItem, useSchedulerEditSlotFormItemContext, DateHeaderCell, SchedulerHeader, SchedulerFooter } from "@progress/kendo-react-scheduler";
import { DatePicker, Calendar, CalendarCell } from "@progress/kendo-react-dateinputs";
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import SweetAlertService from "../../../services/SweetAlertService";
import DiaryService from "../Services/DiaryService";
import { AppConstants, EmployerNamePattern, EmployerNamePatternForReport } from "../Shared/Constants/AppConstant";
import { FormWithCustomEditor } from "./CustomForm";
import './Diary.css';
import { Dialog, DialogActionsBar, } from "@progress/kendo-react-dialogs";
import { IntlProvider, load, loadMessages, LocalizationProvider, useInternationalization } from '@progress/kendo-react-intl';
import weekData from 'cldr-core/supplemental/weekData.json';
import moment from "moment";
import caGregorian from "cldr-dates-full/main/en/ca-gregorian.json";
import enMessages from './en.json';
import { drawDOM, Group, pdf } from "@progress/kendo-drawing";
import { SchedulerViewDateRangeArgs } from "@progress/kendo-react-scheduler/dist/npm/models";
import { Modal, Spinner } from "react-bootstrap";
import { useAuth } from "../../../providers/AuthProvider";
import { RRule } from "rrule";

//To set kendo date picker format in scheduler
caGregorian.main['en'].dates.calendars.gregorian.dateFormats.short = 'dd/MM/yyyy';

//To load custom messages to show core hours
loadMessages(enMessages, 'en-GB');

//To set first day of week as monday
weekData.supplemental.weekData.firstDay.US = 'mon';
load(weekData, caGregorian);

export const Diary = () => {
    const { register, setValue, getValues, formState: { errors } } = useForm();
    const [employerList, setEmployerList] = useState([]);
    const [dairyActivityList, setDairyActivityList] = useState([]);
    const [employerId, setEmployerId] = useState();
    const [selectedEmployerIds, setSelectedEmployerIds] = useState<any>([]);
    const [selectedSubRoleId, setSelectedSubRoleId] = useState<number>(0);
    const [activityList, setActivityList] = useState([]);
    const [diaryActivityListToValidate, setDiaryActivityListToValidate] = useState([]);
    const [activeView, setActiveView] = useState(AppConstants.dayView);
    const [currentTimeMarker, setCurrentTimeMarker] = useState(true);
    const [isActiveViewLoaded, setIsActiveViewLoaded] = useState(false);
    const [currentDiaryDate, setCurrentDiaryDate] = useState(moment(new Date(), 'dd/mm/yyyy', true));
    const [copyToDate, setCopyToDate] = useState<Date | null>(null);
    const [copyMode, setCopyMode] = useState("2");

    useEffect(() => {
        const element = document.querySelectorAll('.k-datepicker input');
        if (element) {
            element.forEach(x => {
                x.addEventListener('wheel', function (event) {
                    event.stopImmediatePropagation();
                });
                x.addEventListener('keydown', function (event) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                });
            });
        }
    }, [activeView]);

    const CustomCalendar = (props: any, showDayInCalednder: any) => {
        const customCell = (props: any) => {
            const isDisabled = showDayInCalednder && !(props.title && props.title.includes(showDayInCalednder));
            return (
                <CalendarCell {...props} isDisabled={isDisabled} />
            )
        }
        return (
            <>
                <Tooltip anchorElement="target" position="top">
                    <Calendar {...props} cell={customCell} />
                </Tooltip>
            </>
        );
    }

    const auth = useAuth();

    //For pdf generation
    const [periodCovered, setPeriodCovered] = useState("");
    const [todayActivityListForReport, setTodayActivityListForReport] = useState([]);
    const [reportEmployerList, setReportEmployerList] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [showReport, setShowReport] = useState(false);
    const [showExportPdf, setShowExportPdf] = useState(false);
    const [showPdfWorkHours, setShowPdfWorkHours] = useState(true);
    const [exportPdfDate, setExportPdfDate] = useState(new Date());
    const _element = useRef<HTMLDivElement>(null);
    const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
    const dateRangeMap: any = {
        day: DayView?.defaultProps?.dateRange,
        week: WeekView?.defaultProps?.dateRange,
    };
    const numberOfDaysMap: any = {
        day: DayView.defaultProps?.numberOfDays,
        week: WeekView.defaultProps?.numberOfDays,
    };
    const intl = useInternationalization();

    useEffect(() => {
        //To keep datetime in local format
        Date.prototype.toJSON = function () { return moment(this).format(); }
        getDiaryActiveView();
        getAllEmployersForDiary();
        //To hide current timer line if it is outside cire hours
        let time = moment().format("HH:mm");
        if (time > AppConstants.workDayEnd) {
            setCurrentTimeMarker(false);
        }
    }, []);

    useEffect(() => {
        //To attach a function handler to show full day/ show core hours toggle
        const element = document.querySelectorAll('.k-toolbar-item.k-scheduler-navigation')[0];
        if (element) {
            element.addEventListener('click', function (event) { handleCoreHoursButtonToggle(event); });
        }
    }, [isActiveViewLoaded]);

    //To enable current time marker on show full day
    const handleCoreHoursButtonToggle = (event: any) => {
        if (event.target.innerText == 'Show full day') {
            setShowPdfWorkHours(false);
            //setCurrentTimeMarker(true);
        } else {
            setShowPdfWorkHours(true);
            //setCurrentTimeMarker(false);
        }
    }

    //To get persisted diary view when user left diary page
    const getDiaryActiveView = () => {
        DiaryService.getDiaryActiveView().then((response: any) => {
            if (response.data) {
                setActiveView(response.data);
                setIsActiveViewLoaded(true);
            }
        }).catch(() => {
            SweetAlertService.error("Error", "Something went wrong while getting active view");
        });
    }

    // calling api to get all work activity for diary
    const getAllActivityForDiary = (subRoleId: number) => {
        DiaryService.getAllWorkActivitiesForDiary(subRoleId).then((response) => {
            if (response.data) {
                //To add other option in the activity list
                let otherActivity = {
                    id: -1,
                    name: AppConstants.otherActivityName,
                    jobSubCategoryId: AppConstants.otherActivitySubCatgoryId,
                }
                response.data.push(otherActivity);
                //set the work activity list
                setActivityList(response.data);
            }
        })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while getting work activities");
            });
    }

    // calling api to get all employers
    const getAllEmployersForDiary = () => {
        DiaryService.getAllEmployersForDiary().then((response) => {
            //set the employers list
            if (response.data.length > 0) {
                setEmployerList(response.data);
                setValue("showEmployer", AppConstants.showSelectedEmployer);
                setEmployerId(response.data[0].id);
                setSelectedEmployerIds([response.data[0].id]);

                // Set SubRole from first employer and get activities
                const firstEmployerSubRoleId = response.data[0].subRoleId;
                setSelectedSubRoleId(firstEmployerSubRoleId);
                getAllActivityForDiary(firstEmployerSubRoleId);

                // calling the methed to get employers diary basesed on default selected employer id
                getAllDiaryActivities([response.data[0].id], currentDiaryDate);
            }
            //if there is no current employers, showing the sweetalert in diary
            else {
                SweetAlertService.info(" ", "You cannot view this page as you do not have any active workplace details.");
            }

        })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while getting job categories");
            });
    }

    //To map recurrence exceptions
    const getExceptions = (recurrenceExceptions: any) => {
        let arr: any = [];
        recurrenceExceptions.map((res: any) => {
            arr.push(new Date(res));
        })
        return arr;
    }

    // calling the api to get employers diary basesed on default selected employer id or all employers ids
    const getAllDiaryActivities = (employerids: any, currentDiaryDate: any) => {
        setIsShowLoader(true);
        DiaryService.getDiaryActivitesByMemberEmployers(employerids, currentDiaryDate).then((response) => {
            if (response && response.data) {
                let regularex = EmployerNamePattern;
                response.data.diaryActivities.map((res: any) => {
                    res.start = new Date(res.start);
                    res.end = new Date(res.end);
                    if (res.recurrenceExceptions && res.recurrenceExceptions.length > 0) {
                        res.recurrenceExceptions = getExceptions(res.recurrenceExceptions);
                    }
                    //To check if the user have more than one employer
                    if (employerids.length > 1) {
                        //To check if the system defined employer name
                        if (!res.isPublicHoliday && regularex.test(res.title)) {
                            res.title = res.title.slice(0, 3) + res.title.slice(10);
                        }
                        //To check if the user defined employer name
                        else if (!res.isPublicHoliday && (res.title.split('-')[0].length > 15)) {
                            let employerNameEndingIndex = res.title.indexOf('-');
                            res.title = res.title.slice(0, 15) + res.title.slice(employerNameEndingIndex);
                        }
                    }
                    //To check if the user have only one employer
                    else if (!res.isPublicHoliday) {
                        let employerNameEndingIndex = res.title.indexOf('-');
                        res.title = res.title.slice(employerNameEndingIndex + 1);
                    }
                });
                //set the dairy list
                setDairyActivityList(response.data.diaryActivities);

                const originalArray = [] = response.data.diaryActivities;
                const diaryActivityListForEmployer = [] = originalArray.map((obj: any) => ({ ...obj }));
                setReportData(diaryActivityListForEmployer);
                response.data.diaryActivitiesToValidate.map((res: any) => {
                    res.start = new Date(res.start);
                    res.end = new Date(res.end);
                })
                setDiaryActivityListToValidate(response.data.diaryActivitiesToValidate);
            }
            setIsShowLoader(false);
        })
            .catch(() => {
                setIsShowLoader(false);
                SweetAlertService.error("Error", "Something went wrong while getting diary activities");
            });
    }

    // calling the api to get employers diary basesed on dropdown change and checking the radio button selection
    const onEmployerChange = (employerid: any) => {
        setEmployerId(employerid);

        // Get SubRole from selected employer and update activities
        const selectedEmployer: any = employerList.find((emp: any) => emp.id == employerid);
        if (selectedEmployer) {
            setSelectedSubRoleId(selectedEmployer.subRoleId);
            getAllActivityForDiary(selectedEmployer.subRoleId);
        }

        let employerids: any[] = [];
        if (getValues("showEmployer") == AppConstants.showSelectedEmployer) {
            setSelectedEmployerIds([Number(employerid)]);
            employerids.push(Number(employerid));
        } else if (getValues("showEmployer") == AppConstants.showAllEmployers) {
            employerList.map((data: any) => {
                employerids.push(data.id);
            })
            setSelectedEmployerIds(employerids);
        }
        // calling the methed to get employers diary basesed on default selected employer id or all employers ids
        setDairyActivityList([]);
        setReportData([]);
        setDiaryActivityListToValidate([]);
        getAllDiaryActivities(employerids, currentDiaryDate);
    }

    // calling the api to get employers diary basesed on radio button selection
    const showEmployerSelected = (e: any) => {
        let employerids: any[] = [];
        if (e == AppConstants.showSelectedEmployer) {
            // getting the employers id from the drop-down
            if (getValues("employerId")) {
                setSelectedEmployerIds([Number(getValues("employerId"))]);
                employerids = [Number(getValues("employerId"))];
            } else {
                // First time on the page load we won't get the employer id from drop-down, so geeting from the respone
                setSelectedEmployerIds([employerId]);
                employerids = [employerId];
            }
        } else if (e == AppConstants.showAllEmployers) {
            employerList.map((data: any) => {
                employerids.push(data.id);
            })
            setSelectedEmployerIds(employerids);
        }
        setDairyActivityList([]);
        setReportData([]);
        setDiaryActivityListToValidate([]);
        getAllDiaryActivities(employerids, currentDiaryDate);
    }

    const customModelFields = {
        id: "id",
        start: "start",
        end: "end",
        memberEmployerId: "memberEmployerId",
        isOnDuty: "isOnDuty",
        jobCategoryId: "jobCategoryId",
        jobSubCategoryId: "jobSubCategoryId",
        recurrenceRule: "recurrenceRule",
        recurrenceId: "recurrenceId",
        recurrenceExceptions: "recurrenceExceptions",
        notes: "notes",
        isAllDay: "isAllDay"
    };

    const CustomItem = (props: SchedulerItemProps) => {
        let color = "grey";
        let textColor = "white"; // Default text color
        if (props && props.dataItem) {
            //Set colors for the different categories based on jobcategoryid
            color = props.dataItem.isPublicHoliday ? "#B7B7B7"
                : props.dataItem.jobCategoryId == AppConstants.DCC_Category_Id ? "#0967B1"
                    : props.dataItem.jobCategoryId == AppConstants.ICC_Category_Id ? "#DA1F6C"
                        : props.dataItem.jobCategoryId == AppConstants.Non_Clinical_Work_Category_Id ? "#008E82"
                            : props.dataItem.jobCategoryId == AppConstants.Training_And_Supervision_Category_Id ? "#6F4F9B"
                                : props.dataItem.jobCategoryId == AppConstants.CPD_Category_Id ? "#EA580D"
                                    : props.dataItem.jobCategoryId == AppConstants.Break_Category_Id ? "#B7B7B7"
                                        : props.dataItem.jobCategoryId == AppConstants.Leave_Category_Id ? "#50535A"
                                            : props.dataItem.jobCategoryId == AppConstants.Academic_Category_Id ? "#000000"
                                                : props.dataItem.isSystemDefinedCategory == false ? "#76A227"
                                                    : props.dataItem.jobCategoryId == AppConstants.Duty_On_Call_Period_Category_Id ? "#E9E9E9"
                                                        : "#78ad88";
            // Set text color based on jobcategoryid
            textColor = props.dataItem.jobCategoryId == AppConstants.Duty_On_Call_Period_Category_Id ? "black" : "white";
        }
        return (
            <SchedulerItem
                {...props}
                style={{
                    ...props.style,
                    backgroundColor: color,
                    color: textColor
                }}
            />
        )
    }

    const handleDataChange = ({
        created,
        updated,
        deleted,
    }: SchedulerDataChangeEvent) => {
        //To add diary activity
        setIsShowLoader(true);
        if (updated.length > 0 && created.length > 0) {
            let activityToAdd = created[0];
            let activityToUpdate = updated[0];
            activityToAdd.currentOccurenceRef = activityToUpdate.recurrenceExceptions[activityToUpdate.recurrenceExceptions.length - 1];
            DiaryService.addDiaryActivities(activityToAdd).then((response) => {
                if (response) {
                    if (activityToUpdate && activityToUpdate.recurrenceRule) {
                        let options = RRule.parseString(activityToUpdate.recurrenceRule);
                        options.dtstart = activityToUpdate.start;
                        var rule = new RRule(options);
                        console.log(rule.all());
                        let occurences = rule.all();
                        activityToUpdate.recurringActivityOccurences = occurences;
                    }
                    updateActivity(activityToUpdate);
                    //SweetAlertService.success("Success", "Diary Activity updated successfully");
                } else {
                    setIsShowLoader(false);
                    SweetAlertService.error("Error", "Something went wrong while updating diary activity");
                }
            }).catch(error => {
                if (error) {
                    console.log(error);
                    setIsShowLoader(false);
                    SweetAlertService.error("Error", error.response.data);
                }
            });
        } else {
            if (created.length > 0) {
                let activityToAdd = created[0];
                if (activityToAdd && activityToAdd.recurrenceRule) {
                    let options = RRule.parseString(activityToAdd.recurrenceRule);
                    options.dtstart = activityToAdd.start;
                    var rule = new RRule(options);
                    console.log(rule.all());
                    let occurences = rule.all();
                    activityToAdd.recurringActivityOccurences = occurences;
                }
                createActivity(activityToAdd, true);
            }

            //To delete diary activity
            if (deleted.length > 0) {
                let activityToDelete = deleted[0].id;
                deleteActivty(activityToDelete);
            }

            //To edit diary activity
            if (updated.length > 0) {
                let activityToUpdate = updated[0];
                if (activityToUpdate && activityToUpdate.recurrenceRule) {
                    let options = RRule.parseString(activityToUpdate.recurrenceRule);
                    options.dtstart = activityToUpdate.start;
                    var rule = new RRule(options);
                    console.log(rule.all());
                    let occurences = rule.all();
                    activityToUpdate.recurringActivityOccurences = occurences;
                }
                updateActivity(activityToUpdate);
            }
        }
    };

    const updateActivity = (activity: any) => {
        //To check activity is all-day event
        if (activity.isAllDay) {
            activity.start = new Date(activity.start.getFullYear(), activity.start.getMonth(), activity.start.getDate(), 0, 0, 0);
            activity.end = new Date(activity.end.getFullYear(), activity.end.getMonth(), activity.end.getDate(), 23, 59, 59);
        }
        DiaryService.updateDiaryActivity(activity.id, activity).then((response) => {
            if (response) {
                SweetAlertService.success("Success", "Activity updated successfully");
                getAllDiaryActivities(selectedEmployerIds, currentDiaryDate);
            } else {
                setIsShowLoader(false);
                SweetAlertService.error("Error", "Something went wrong while updating diary activity");
            }
        }).catch(error => {
            if (error) {
                console.log(error);
                setIsShowLoader(false);
                SweetAlertService.error("Error", error.response.data);
            }
        });
    }

    const createActivity = (activity: any, showAlert: any) => {
        //To check activity is all-day event
        if (activity.isAllDay) {
            activity.start = new Date(activity.start.getFullYear(), activity.start.getMonth(), activity.start.getDate(), 0, 0, 0);
            activity.end = new Date(activity.end.getFullYear(), activity.end.getMonth(), activity.end.getDate(), 23, 59, 59);
        }
        DiaryService.addDiaryActivities(activity).then((response) => {
            if (response.data > 0) {
                if (showAlert) {
                    SweetAlertService.success("Success", "Activity added successfully");
                }
                getAllDiaryActivities(selectedEmployerIds, currentDiaryDate);
            } else {
                setIsShowLoader(false);
                SweetAlertService.error("Error", "Something went wrong while adding diary activity");
            }
        }).catch(error => {
            if (error) {
                console.log(error);
                setIsShowLoader(false);
                SweetAlertService.error("Error", error.response.data);
            }
        });
    }

    //To delete diary activity
    const deleteActivty = (id: any) => {
        DiaryService.deleteDiaryActivity(id).then((response) => {
            if (response) {
                SweetAlertService.success("Success", "Activity deleted successfully");
                getAllDiaryActivities(selectedEmployerIds, currentDiaryDate);
            } else {
                setIsShowLoader(false);
                SweetAlertService.error("Error", "Something went wrong while deleted diary activity");
            }
        }).catch(error => {
            if (error) {
                console.log(error);
                setIsShowLoader(false);
                SweetAlertService.error("Error", "Something went wrong while deleted diary activity");
            }
        });
    }

    const intersects = (
        startTime1: Date,
        endTime1: Date,
        startTime2: Date,
        endTime2: Date
    ) =>
        (startTime1 < startTime2 && endTime1 > endTime2) ||
        (startTime2 <= startTime1 && startTime1 < endTime2) ||
        (startTime2 < endTime1 && endTime1 <= endTime2);

    const CustomSlot = (props: any) => {
        const [, setFormItem] = useSchedulerEditSlotFormItemContext();
        const createDataItemFromSlot = useCallback(() => {
            const dataItem: any = {};
            dataItem.memberEmployerId = Number(employerId);
            dataItem.start = new Date(props.start.getTime());
            dataItem.end = new Date(new Date(props.end.getTime()));
            dataItem.isAllDay = false;
            dataItem.isOnDuty = false;
            return dataItem;
        }, [props.end, props.isAllDay, props.start, props.memberEmployerId, props.isOnDuty]);
        const handleClick = useCallback(
            (event: any) => {
                const dataItem = createDataItemFromSlot();
                if (props.isAllDay) {
                    dataItem.end = new Date(dataItem.start.getFullYear(), dataItem.start.getMonth(), dataItem.start.getDate(), 23, 59, 59);
                }
                setFormItem(dataItem);

                if (props.onClick) {
                    props.onClick(event);
                }
            },
            [createDataItemFromSlot, props, setFormItem]
        );

        let isCurrentDay = false;
        let isMonthView = activeView == AppConstants.monthView;
        if (isMonthView) {
            const date = props.start;
            if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
                isCurrentDay = true;
            }
        }

        var color = 'white';
        //To change the slot color if other employer activity exits 
        var start = new Date(props.start.getTime());
        var end = new Date(props.end.getTime());
        if (selectedEmployerIds.length == 1) {
            var memberEmployerId = selectedEmployerIds[0];
            var isOtherEmployerActivityExist = !props.isAllDay && diaryActivityListToValidate.some((x: any) =>
                x.memberEmployerId != memberEmployerId && !x.isAllDay && intersects(start, end, x.start, x.end)
            );
            var isOtherEmployerAllDayActivityExist = props.isAllDay && diaryActivityListToValidate.filter((x: any) =>
                x.memberEmployerId != memberEmployerId && x.isAllDay && !x.isPublicHoliday
                && moment(new Date(x.start.getFullYear(), x.start.getMonth(), x.start.getDate(), 0, 0, 0)).isSame(props.start)
            ).length > 0;

            if (isOtherEmployerActivityExist || isOtherEmployerAllDayActivityExist) {
                color = 'grey';
            }
        }
        //To change the slot color if archieved employer activity exits
        else {
            var memberEmployerId = selectedEmployerIds;
            var isOtherEmployerActivityExist = !props.isAllDay && diaryActivityListToValidate.some((x: any) =>
                !memberEmployerId.includes(x.memberEmployerId) && !x.isAllDay && intersects(start, end, x.start, x.end)
            );
            var isOtherEmployerAllDayActivityExist = props.isAllDay && diaryActivityListToValidate.filter((x: any) =>
                !memberEmployerId.includes(x.memberEmployerId) && x.isAllDay && !x.isPublicHoliday
                && moment(new Date(x.start.getFullYear(), x.start.getMonth(), x.start.getDate(), 0, 0, 0)).isSame(props.start)
            ).length > 0;

            if (isOtherEmployerActivityExist || isOtherEmployerAllDayActivityExist) {
                color = 'grey';
            }
        }

        return (
            <SchedulerSlot
                {...props}
                onDoubleClick={handleClick}
                style={{
                    ...props.style,
                    backgroundColor: isCurrentDay && isMonthView ? '#cff4fc' : color,
                }}
            />
        );
    };

    const customEditItem = (props: SchedulerEditItemProps) => {
        let newProps = { ...props };
        //To disable edit option for public holidays
        if (newProps.dataItem.isPublicHoliday) {
            newProps.editable = false;
        } else {
            newProps.editable = {
                remove: true,
                resize: true,
                add: true,
                edit: true,
                select: true,
                drag: true,
            }
        }

        const [isCurrentOccurrence, setIsCurrentOccurrence] = useState(false);
        const [isOccurrence, setIsOccurrence] = useState(false);
        const customRemoveDialog = (props: any) => {
            return (isOccurrence ?
                <Dialog title={"Delete Recurring Activity"} onClose={props.onClose} >
                    <p style={{ marginTop: "5%", textAlign: "center" }}>
                        {isCurrentOccurrence && <>Are you sure you want to delete this event occurrence? </>}
                        {!isCurrentOccurrence && <>Are you sure you want to delete the whole series? </>}
                    </p>
                    <DialogActionsBar layout={'end'}>
                        <button className="btn btn-primary" onClick={props.onConfirm}>
                            Delete
                        </button>
                        <button className="btn btn-secondary" onClick={props.onCancel}>
                            Cancel
                        </button>
                    </DialogActionsBar>
                </Dialog>
                :
                <Dialog title={"Delete activity"} onClose={props.onClose} >
                    <p style={{ marginTop: "5%", textAlign: "center" }}>
                        Are you sure you want to delete this activity?
                    </p>
                    <DialogActionsBar layout={'end'}>
                        <button className="btn btn-primary" onClick={props.onConfirm}>
                            Delete
                        </button>
                        <button className="btn btn-secondary" onClick={props.onCancel}>
                            Cancel
                        </button>
                    </DialogActionsBar>
                </Dialog>
            );
        }

        const customOccuranceDialog = (props: any) => {
            useEffect(() => {
                setIsOccurrence(true);
            }, []);
            return (props.isRemove ?
                <Dialog title={"Delete Recurring Activity"} onClose={props.onClose} >
                    <p style={{ marginTop: "5%", textAlign: "center" }}>
                        Do you want to delete only this event occurrence or the whole series?
                    </p>
                    <DialogActionsBar layout={'end'}>
                        <button className="btn btn-primary" onClick={(event) => {
                            setIsCurrentOccurrence(true);
                            props.onOccurrenceClick(event);
                        }}>
                            Delete current occurrence
                        </button>
                        <button className="btn btn-secondary" onClick={(event) => { setIsCurrentOccurrence(false); props.onSeriesClick(event); }}>
                            Delete the series
                        </button>
                    </DialogActionsBar>
                </Dialog> :
                <Dialog title={"Edit Recurring Activity"} onClose={props.onClose} >
                    <p style={{ marginTop: "5%", textAlign: "center" }}>
                        Do you want to edit only this event occurrence or the whole series?
                    </p>
                    <DialogActionsBar layout={'end'}>
                        <button className="btn btn-primary" onClick={(event) => {
                            setIsCurrentOccurrence(true);
                            props.onOccurrenceClick(event);
                        }}>
                            Edit current occurrence
                        </button>
                        <button className="btn btn-secondary" onClick={(event) => { setIsCurrentOccurrence(false); props.onSeriesClick(event); }}>
                            Edit the series
                        </button>
                    </DialogActionsBar>
                </Dialog>
            );
        }

        return (
            <SchedulerEditItem
                {...newProps}
                occurrenceDialog={customOccuranceDialog}
                removeDialog={customRemoveDialog} />
        );
    }

    const customDayViewDateHeaderCell = (props: any) => {
        let isCurrentDay = false;
        if (props.start.toLocaleDateString() === new Date().toLocaleDateString()) {
            isCurrentDay = true;
        }
        return (
            <DateHeaderCell {...props} style={{
                ...props.style,
                backgroundColor: isCurrentDay ? '#cff4fc' : 'white',
                fontSize: "0px"
            }}>
            </DateHeaderCell>
        )
    }

    const customWeekViewDateHeaderCell = (props: any) => {
        let isCurrentDay = false;
        if (props.start.toLocaleDateString() === new Date().toLocaleDateString()) {
            isCurrentDay = true;
        }
        return (
            <DateHeaderCell {...props} format="EEE dd" style={{
                ...props.style,
                backgroundColor: isCurrentDay ? '#cff4fc' : 'white',
            }}>
            </DateHeaderCell>
        )
    }

    const onViewChange = (props: any) => {
        setCopyToDate(null);
        setActiveView(props.value);
        const payLoad = { viewType: props.value };
        DiaryService.saveDiaryActiveView(payLoad).then((response) => {
            if (response.data) {
                console.log(response);
            } else {
                SweetAlertService.error("Error", "Something went wrong while saving diary active view");
            }
        })
    }

    //On date change in diary 
    const handleDateChange = (props: any) => {
        let userSelectedDate = props.value._localDate ? props.value._localDate : props.value;
        setCurrentDiaryDate(moment(userSelectedDate, 'dd/mm/yyyy', true));
        setExportPdfDate(userSelectedDate);
        //Get all diary activites the api on date change in diary
        setDairyActivityList([]);
        setReportData([]);
        setDiaryActivityListToValidate([]);
        getAllDiaryActivities(selectedEmployerIds, userSelectedDate);
    }

    useEffect(() => {
        window.addEventListener('error', e => {
            if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'ResizeObserver loop completed with undelivered notifications.') {
                const resizeObserverErrDiv = document.getElementById(
                    'webpack-dev-server-client-overlay-div'
                );
                const resizeObserverErr = document.getElementById(
                    'webpack-dev-server-client-overlay'
                );
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        });
    }, []);

    const handleCloseReportModal = () => {
        setShowReport(false);
    }

    const onExportPdfClick = () => {
        let regularex = EmployerNamePatternForReport;
        var defaultEmployers = employerList.every((x: any) => regularex.test(x.employerName));
        if (defaultEmployers || employerList.length == 1 || getValues("showEmployer") == AppConstants.showSelectedEmployer) {
            onExport();
        }
        else {
            setShowReport(true);
            setValue("showEmployerInReport", AppConstants.inCludeEmployerNameInReport);
            document.body.style.overflow = "hidden";
        }
    }

    const getEmployerName = (employerList: any, memberEmployerId: any) => {
        let employer = employerList.filter((x: any) => x.id == memberEmployerId)[0];
        return employer ? employer.name : "";
    }

    const onReportGenerate = () => {
        if (getValues("showEmployerInReport") == AppConstants.excludeEmployerNameInReport) {
            onExport();
        } else {
            let employer: any = [];
            employerList.map((emp: any, index: any) => {
                employer.push({ id: emp.id, name: "Emp " + (Number(index) + 1) })
            });

            const originalData = [] = reportData;
            const reportToModifyData: any = [] = originalData.map((obj: any) => ({ ...obj }));

            reportToModifyData.map((activity: any) => {
                let employerName = activity.title.split("-");
                activity.title = getEmployerName(employer, activity.memberEmployerId) + "-" + employerName[1] + "-" + employerName[2];
            });

            setReportData(reportToModifyData);
            onExport();
        }
    }

    //Check any recuurning activity modified by current occurence exists
    const checkOccurenceTypeExists = (occurenceType: any, todayActivities: any) => {
        return !todayActivities.some((x: any) => x.occurenceType == occurenceType)
    }

    const setNotesContentAndEmployerContent = (dateRange: any) => {
        const hideEmployerName = getValues("showEmployerInReport");
        const originalData = [] = reportData;
        const reportToModifyData: any = [] = originalData.map((obj: any) => ({ ...obj }));

        let todayActivities = reportToModifyData.filter((x: any) => x.start >= dateRange.start && x.end <= dateRange.end);
        //To get all activities including reccuring activities
        const recuuringActivityData = [] = diaryActivityListToValidate.filter((x: any) => x.start >= dateRange.start && x.end <= dateRange.end && x.recurrenceId && x.occurenceType == 300);
        let empList: any = [];
        let employer: any = [];
        let todayActivitiesWithReccuringActivities: any = [];
        let reccurenceActivityIds: any = [];
        employerList.map((emp: any, index: any) => {
            employer.push({ id: emp.id, name: "Emp " + (Number(index) + 1) })
        });

        // To get list of recurring activity ids 
        todayActivities.filter((x: any) => x.recurrenceRule != null).map((activity: any) => {
            reccurenceActivityIds.push(activity.id);
        })

        let reccurenceActivityExists = reccurenceActivityIds.length > 0;

        //To get only recuuring activities
        recuuringActivityData.map((activity: any) => {
            if (reccurenceActivityExists) {
                //Check any recuurning activity modified by current occurence exists
                if (reccurenceActivityIds.includes(activity.recurrenceId) && activity.occurenceType && checkOccurenceTypeExists(activity.occurenceType, todayActivities)) {
                    todayActivitiesWithReccuringActivities.push(activity);
                }
            } else {
                todayActivitiesWithReccuringActivities.push(activity);
            }
        })

        //Get all activities expect reccuring activites
        todayActivities.filter((x: any) => x.recurrenceRule == null).map((activity: any) => {
            todayActivitiesWithReccuringActivities.push(activity);
        })

        todayActivitiesWithReccuringActivities.map((activity: any) => {
            let empName = "";
            if (hideEmployerName == AppConstants.inCludeEmployerNameInReport) {
                empName = getEmployerName(employer, activity.memberEmployerId);
                let employerName = activity.title.split("-");
                activity.title = getEmployerName(employer, activity.memberEmployerId) + "-" + employerName[1] + "-" + employerName[2];
            } else {
                empName = activity.title.split("-")[0];
            }
            if (empList.indexOf(empName) < 0) {
                empList.push(empName);
            }
        })
        setReportEmployerList(empList);
        setTodayActivityListForReport(todayActivitiesWithReccuringActivities);
    }

    const onExport = async () => {
        setShowReport(false);
        document.body.style.overflow = "hidden";
        setShowExportPdf(true);
        await delay(200);
        exportElement(_element.current, { scale: [0.6, 0.75] });
    }

    const handleCopyActivities = () => {
        if (!copyToDate) {
            SweetAlertService.error("Error", "Please select a date to copy to.");
            return;
        }
        let isWeek = activeView === AppConstants.weekView;
        let fromDate = moment(currentDiaryDate);
        if (isWeek) {
            fromDate = fromDate.day(1);
        }
        let formattedFromDate = fromDate.local().format('YYYY-MM-DD');
        let formattedToDate = moment(copyToDate).local().format('YYYY-MM-DD');
        if (formattedFromDate == formattedToDate) {
            SweetAlertService.error("Error", "Please enter a valid date.");
            return;
        }
        let payload: any = {
            MemberEmployerIds: copyMode === "1" ? employerList.map((e: any) => e.id) : [employerId],
            FromDate: formattedFromDate,
            ToDate: formattedToDate,
            IsWeek: isWeek,
            IsConfirmDelete: false
        };
        setIsShowLoader(true);
        DiaryService.copyActivities(payload).then((response: any) => {
            setIsShowLoader(false);
            if (response.data.isConfirmDelete) {
                SweetAlertService.confirmCustom("Confirmation", response.data.responseText, "Yes", "No")
                    .then((confirmed: any) => {
                        if (confirmed.isConfirmed) {
                            payload.IsConfirmDelete = true;
                            setIsShowLoader(true);
                            DiaryService.copyActivities(payload).then((res: any) => {
                                setIsShowLoader(false);
                                if (res.data.isSuccess) {
                                    SweetAlertService.success("Success", "Activities copied successfully.");
                                    setCopyToDate(null);
                                    // Refresh logic if needed, e.g. reload activities if on target date
                                    getAllDiaryActivities(selectedEmployerIds, currentDiaryDate);
                                } else {
                                    SweetAlertService.error("Error", res.data.responseText);
                                }
                            });
                        }
                    });
            } else if (response.data.isSuccess) {
                SweetAlertService.success("Success", "Activities copied successfully.");
                setCopyToDate(null);
                getAllDiaryActivities(selectedEmployerIds, currentDiaryDate);
            } else {
                SweetAlertService.error("Error", response.data.responseText);
            }
        }).catch((error: any) => {
            setIsShowLoader(false);
            console.log(error);
            SweetAlertService.error("Error", "An error occurred while copying activities.");
        });
    }

    const [renderCount, setRenderCount] = useState(0);

    const exportElement = async (element: any, options: any) => {
        const numberOfDays = numberOfDaysMap[activeView];
        let group = new Group();
        let obj: SchedulerViewDateRangeArgs = { date: exportPdfDate, intl: intl, timezone: undefined, numberOfDays: numberOfDays };
        const dateRange = dateRangeMap[activeView](obj);
        if (activeView == AppConstants.dayView) {
            setPeriodCovered(moment(dateRange.start).format('DD/MM/YYYY'));
        } else {
            setPeriodCovered(moment(dateRange.start).format('DD/MM/YYYY') + ' - ' + moment(dateRange.end - 1).format('DD/MM/YYYY'));
        }

        setNotesContentAndEmployerContent(dateRange);
        await delay(200);
        await drawDOM(element, options).then(async (groupDay) => {
            groupDay.options.set('pdf', {
                paperSize: 'auto',
                multiPage: true,
                margin: {
                    left: '1cm',
                    top: '1cm',
                    right: '1cm',
                    bottom: '1cm',
                },
            });
            group.options = groupDay.options;
            group.append(groupDay);
            if (group.children.length > 0) {
                pdf.saveAs(group, 'export.pdf');
                document.body.style.overflow = "";
                await setReportData(reportData);
                setValue("showEmployerInReport", AppConstants.excludeEmployerNameInReport);
                setShowExportPdf(false);
            }
        });
    }

    const [isShowLoader, setIsShowLoader] = useState<any>(false);

    let notesStartDateList: any = [];

    return (
        <>
            {isShowLoader &&
                <div className="loader-backdrop">
                    <Spinner animation="border" variant="primary" />
                </div>
            }
            <div className="hero-banner hero-banner--background hero-banner--subpage">
                <div className="container">
                    <div className="hero-banner__image-container mt-4">
                        <div className="front-start">
                            <h1>Diary</h1>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="front-start mb-2 control-label">Select workplace details</label>
                                    <select className="form-select"
                                        {...register("employerId",)}
                                        defaultValue={employerId}
                                        onChange={(e) => onEmployerChange(e.target.value)} >
                                        if (employeerList.length)
                                        {
                                            employerList.map((e: any) => (
                                                <option value={e.id} key={e.id}>{e.employerName}</option>
                                            ))
                                        }
                                    </select>
                                    {
                                        employerList.length && employerList.length > 1 ?
                                            (
                                                <div className="mt-3">
                                                    <label className="checkbox-inline">
                                                        <input value="1" type="radio"
                                                            {...register("showEmployer")}
                                                            onChange={(e) => showEmployerSelected(e.target.value)}
                                                        />&nbsp;Show all
                                                        <input className="ms-3" value="2" type="radio"
                                                            {...register("showEmployer")}
                                                            onChange={(e) => showEmployerSelected(e.target.value)}
                                                        />&nbsp;Show selected
                                                        <span className="text-danger field-validation-valid"></span>
                                                    </label>
                                                </div>
                                            ) : <div></div>
                                    }
                                    {
                                        activeView != AppConstants.monthView &&
                                        (
                                            <div className="mt-3">
                                                <button type="button" className="btn btn-primary customLargeBtn" onClick={() => onExportPdfClick()}>Export page as PDF</button>
                                            </div>
                                        )
                                    }
                                </div>
                                {
                                    activeView != AppConstants.monthView &&
                                    (
                                        <div className="col-lg-6 diary-copy-panel">
                                            <div className="form-group">
                                                <label className="front-start mb-2 control-label">
                                                    {activeView === AppConstants.weekView ? "Copy to week starting:" : "Copy today's activities to"}
                                                </label>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <DatePicker
                                                        format="dd/MM/yyyy"
                                                        value={copyToDate}
                                                        onChange={(e) => setCopyToDate(e.value)}
                                                        width="200px"
                                                        calendar={(props) => CustomCalendar(props, activeView === AppConstants.weekView ? "Monday" : "")}
                                                        placeholder="Select date"
                                                        size="large"
                                                    />
                                                    <button type="button" onClick={handleCopyActivities} className="btn btn-primary m-l-xs ms-2">Copy</button>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="radio-options-container">
                                                        <label className="radio-inline me-3">
                                                            <input
                                                                type="radio"
                                                                value="1"
                                                                checked={copyMode === "1"}
                                                                onChange={(e) => setCopyMode(e?.target?.value)}
                                                            />&nbsp;Copy all employers
                                                        </label>
                                                        <label className="radio-inline">
                                                            <input
                                                                type="radio"
                                                                value="2"
                                                                checked={copyMode === "2"}
                                                                onChange={(e) => setCopyMode(e?.target?.value)}
                                                            />&nbsp;Copy selected employer only
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        {
                            isActiveViewLoaded &&
                            (
                                <div className="card-body mt-4">
                                    <LocalizationProvider language="en-GB">
                                        <IntlProvider locale="en-GB">
                                            <Scheduler
                                                view={activeView}
                                                onDataChange={handleDataChange}
                                                onDateChange={handleDateChange}
                                                item={CustomItem}
                                                height="100%"
                                                onViewChange={onViewChange}
                                                editable={{
                                                    remove: true,
                                                    resize: true,
                                                    add: true,
                                                    edit: true,
                                                    select: true,
                                                    drag: true,
                                                }}
                                                data={dairyActivityList}
                                                modelFields={customModelFields}
                                                slot={CustomSlot}
                                                editItem={customEditItem}
                                                form={(props) => FormWithCustomEditor(props, diaryActivityListToValidate, activityList, employerList, deleteActivty)} >
                                                <DayView
                                                    currentTimeMarker={currentTimeMarker}
                                                    dateHeaderCell={customDayViewDateHeaderCell}
                                                    title="Day"
                                                    numberOfDays={1}
                                                    slotDuration={60}
                                                    slotDivisions={2}
                                                    workDayStart={AppConstants.workDayStart}
                                                    workDayEnd={AppConstants.workDayEnd}
                                                    selectedDateFormat="{0:EEE dd/MM/y}"
                                                />
                                                <WeekView
                                                    currentTimeMarker={currentTimeMarker}
                                                    dateHeaderCell={customWeekViewDateHeaderCell}
                                                    selectedDateFormat="{0:EEE dd/MM/y} - {1:EEE dd/MM/y}"
                                                    workDayStart={AppConstants.workDayStart}
                                                    workDayEnd={AppConstants.workDayEnd}
                                                    slotDuration={60}
                                                    slotDivisions={2}
                                                />
                                                <MonthView selectedDateFormat="{0:MMMM  y}" />
                                            </Scheduler>
                                        </IntlProvider>
                                    </LocalizationProvider>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <Modal show={showReport} backdrop="static" onHide={handleCloseReportModal} size="lg">
                <Modal.Header style={{ height: '40px', paddingBottom: "0px" }} className="modal-header-no-border" closeButton>
                    <Modal.Title>Export data as a PDF</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <span>Do you want to hide your employer/practice name?</span><br />
                        <input className="mt-3" value="1" type="radio" {...register("showEmployerInReport")} />&nbsp; Yes<br />
                        <input className="mt-2" value="2" type="radio" {...register("showEmployerInReport")} />&nbsp; No
                    </div>
                </Modal.Body>
                <Modal.Footer className="modal-footer-no-border d-flex justify-content-start">
                    <button className="btn btn-secondary" onClick={handleCloseReportModal}>Cancel</button>
                    <button className="btn btn-primary" onClick={onReportGenerate}>Generate</button>
                </Modal.Footer>
            </Modal>

            {/* For pdf generation */}
            {
                showExportPdf && (
                    <>
                        <div className="loader-backdrop">
                            <Spinner animation="border" variant="primary" />
                        </div>
                        <div className="card-body mt-4 diaryPdfContent" ref={_element}>
                            {
                                renderCount == 0 && (
                                    <>
                                        <h1 className="text-dark fw-normal mb-0">{AppConstants.LoggenInUserLabelForReport} {auth?.getLoggedInUserName()}</h1>
                                        {employerList.length > 1 && getValues("showEmployer") == AppConstants.showAllEmployers && reportEmployerList.map((emp: any, index) => (
                                            <>
                                                <span>{(index == 0 ? "Workplace details : " : ", ") + emp}</span>
                                            </>
                                        ))}
                                        {activeView == AppConstants.weekView && <><br /><span>Period covered: {periodCovered} </span><br /><br /></>}
                                    </>
                                )
                            }
                            {activeView == AppConstants.dayView && <><br /><span>Date: {moment(exportPdfDate).format('DD/MM/YYYY')}</span><br /><br /></>}
                            <LocalizationProvider language="en-GB">
                                <IntlProvider locale="en-GB">
                                    <Scheduler
                                        date={exportPdfDate}
                                        view={activeView}
                                        item={CustomItem}
                                        height="100%"
                                        data={reportData}
                                        slot={CustomSlot}
                                        header={(props) => false ? <SchedulerHeader {...props} /> : <Fragment />}
                                        footer={(props) => false ? <SchedulerFooter {...props} /> : <Fragment />}                                    >
                                        <DayView
                                            currentTimeMarker={currentTimeMarker}
                                            dateHeaderCell={customDayViewDateHeaderCell}
                                            title="Day"
                                            numberOfDays={1}
                                            slotDuration={60}
                                            slotDivisions={2}
                                            workDayStart={AppConstants.workDayStart}
                                            workDayEnd={AppConstants.workDayEnd}
                                            selectedDateFormat="{0:EEE dd/MM/y}"
                                            showWorkHours={showPdfWorkHours}
                                        />
                                        <WeekView
                                            currentTimeMarker={currentTimeMarker}
                                            dateHeaderCell={customWeekViewDateHeaderCell}
                                            selectedDateFormat="{0:EEE dd/MM/y} - {1:EEE dd/MM/y}"
                                            workDayStart={AppConstants.workDayStart}
                                            workDayEnd={AppConstants.workDayEnd}
                                            slotDuration={60}
                                            slotDivisions={2}
                                            showWorkHours={showPdfWorkHours}
                                        />
                                    </Scheduler>
                                </IntlProvider>
                            </LocalizationProvider>
                            <br />
                            {todayActivityListForReport.filter((x: any) => x.notes).sort((first: any, second: any) => first.start - second.start).map((activity: any, index: any) => (
                                <Fragment key={index}>
                                    {(!notesStartDateList.includes(moment(activity.start).format('DD/MM/YYYY')) ? <><span>Notes for : {moment(activity.start).format('DD/MM/YYYY')}</span><br /></> : <></>)}
                                    {employerList.length > 1 && getValues("showEmployer") == AppConstants.showAllEmployers && (<><span>Workplace details: {activity.title.split('-')[0]}</span><br /></>)}
                                    <span>{activity.jobCategoryName} {activity.jobCategoryId != AppConstants.Leave_Category_Id && activity.jobCategoryId != AppConstants.Break_Category_Id && activity.jobCategoryId != AppConstants.Duty_On_Call_Period_Category_Id ? " - " + activity.jobSubCategoryName : ""}</span><br />
                                    <span>{activity.notes}</span><br />
                                    {notesStartDateList.push(moment(activity.start).format('DD/MM/YYYY')) && <></>}<br />
                                </Fragment>
                            ))}
                        </div>
                    </>
                )
            }
        </>
    )
}